import { render, staticRenderFns } from "./UserLearningHistoryLogPage.vue?vue&type=template&id=768d29e8"
import script from "./UserLearningHistoryLogPage.vue?vue&type=script&lang=js"
export * from "./UserLearningHistoryLogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports